import { render } from "./Stairstep.vue?vue&type=template&id=090b2202"
import script from "./Stairstep.vue?vue&type=script&lang=ts"
export * from "./Stairstep.vue?vue&type=script&lang=ts"
script.render = render

export default script